"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var transitionDuration = '0.2s';
var transitionTimingFunction = 'ease-in-out';
var unfoldTranslateY = '-32px';

exports.styles = function (_a) {
  var stateHover = _a.stateHover,
      colorBg = _a.colorBg,
      toneValueBase = _a.toneValueBase,
      colorBorder = _a.colorBorder,
      paddingControlHorizontal = _a.paddingControlHorizontal,
      x4 = _a.x4,
      x15 = _a.x15,
      lineHeight = _a.lineHeight;
  return __assign({
    item: {
      display: 'block',
      width: '100%',
      backgroundColor: colorBg.normal,
      position: 'relative'
    },
    disabled: {
      opacity: toneValueBase,
      pointerEvents: 'none',
      cursor: 'default'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      position: 'relative',
      height: 32,
      paddingTop: x4,
      paddingBottom: x4,
      paddingLeft: 20,
      paddingRight: 20,
      backgroundColor: colorBg.normal,
      '&:hover:not($statical), &$hover:not($statical)': {
        cursor: 'pointer',
        backgroundColor: stateHover(colorBg.normal)
      },
      '&$unfolded': {},
      fallbacks: [{
        display: '-ms-flexbox',
        '-ms-flex-align': 'center',
        '-ms-flex-direction': 'row'
      }, {
        display: '-webkit-box',
        '-webkit-box-align': 'center',
        '-webkit-box-orient': 'horizontal',
        '-webkit-box-direction': 'normal'
      }, {
        display: '-webkit-flex',
        '-webkit-align-items': 'center',
        '-webkit-flex-direction': 'row'
      }]
    },
    headerIcon: {
      marginRight: paddingControlHorizontal,
      fontSize: 0,
      lineHeight: 0,
      '& svg': {
        fill: colorBg.normal
      }
    },
    headerText: {
      display: 'box',
      marginRight: paddingControlHorizontal,
      maxHeight: 2 * lineHeight,
      overflow: 'hidden',
      // вообще дизайнеры не должны такого хотеть, так что это решение
      // не будет работать в лисе, но иначе не сделать, без выравнивания текста по всей ширине
      lineClamp: 2,
      boxOrient: 'vertical',
      textOverflow: 'ellipsis',
      fallbacks: [{
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box'
      }]
    },
    dropDownIcon: {
      width: 16,
      height: 16,
      marginLeft: 'auto'
    },
    body: {
      willChange: 'height',
      transition: "height " + transitionDuration + " " + transitionTimingFunction,
      height: 0,
      overflow: 'hidden',
      '&$unfolded': {
        height: 'auto'
      },
      fallbacks: [{
        '-webkit-transition': "height " + transitionDuration + " " + transitionTimingFunction
      }]
    },
    contentBorder: {
      display: 'block',
      height: 0,
      borderBottom: "1px solid " + colorBorder.normal,
      marginLeft: 20,
      marginRight: 20,
      '&$leftMargin': {
        margin: {
          left: 64,
          right: 20
        }
      }
    },
    contentWrapper: {
      padding: 20,
      willChange: 'opacity, transform',
      transition: "opacity " + transitionDuration + " " + transitionTimingFunction + "," + ("transform " + transitionDuration + " " + transitionTimingFunction),
      opacity: 0,
      transform: "translateY(" + unfoldTranslateY + ")",
      '&$emptyBody': {
        padding: 0
      },
      '&$unfolded': {
        opacity: 1,
        transform: 'translateY(0)'
      },
      '&$leftMargin': {
        paddingLeft: 64
      },
      fallbacks: [{
        transition: "opacity " + transitionDuration + " " + transitionTimingFunction + "," + ("transform " + transitionDuration + " " + transitionTimingFunction + ",") + ("-webkit-transform " + transitionDuration + " " + transitionTimingFunction + ",") + ("-ms-transform " + transitionDuration + " " + transitionTimingFunction)
      }, {
        willChange: 'opacity, -webkit-transform',
        '-webkit-transition': "opacity " + transitionDuration + " " + transitionTimingFunction + "," + ("-webkit-transform " + transitionDuration + " " + transitionTimingFunction),
        '-webkit-transform': "translateY(" + unfoldTranslateY + ")",
        transition: "opacity " + transitionDuration + " " + transitionTimingFunction + "," + ("-webkit-transform " + transitionDuration + " " + transitionTimingFunction)
      }, {
        willChange: 'opacity, -ms-transform',
        '-ms-transform': "translateY(" + unfoldTranslateY + ")",
        transition: "opacity " + transitionDuration + " " + transitionTimingFunction + "," + ("-ms-transform " + transitionDuration + " " + transitionTimingFunction)
      }]
    },
    leftMargin: {},
    unfolded: {},
    hover: {},
    statical: {},
    emptyBody: {}
  }, mobileStylesHelper_1.default({
    '& $header': {
      paddingLeft: x4,
      paddingRight: x4
    },
    '& $contentBorder': {
      marginLeft: x4,
      marginRight: x4
    },
    '& $contentBorder$leftMargin': {
      marginLeft: x15
    },
    '& $contentWrapper': {
      padding: x4
    },
    '& $contentWrapper$emptyBody': {
      padding: 0
    },
    '& $contentWrapper$leftMargin': {
      paddingLeft: x15
    }
  }));
};